import { IEnvironment } from './environment.type';

export const environment: IEnvironment = {
  API_URL: 'https://5aessence.com.br/vidacare_api/api/psicosocial',
  logo_name: 'logo_essence.png',
};
